import styled from "styled-components";
import { getISOWeek } from "utilities/dateAndTime";


const parseActivity = (activity) => {

    const today = new Date();
    let parsedAcvitiy = [];

    for(let i = 0; i < 12; i++)
    {
        let date = new Date(today);
        date.setDate(date.getDate() + (7 * i));
        let code = date.getFullYear() + "W" + getISOWeek(date);
        if(activity[code]) parsedAcvitiy.push(Math.round(activity[code]));
        else parsedAcvitiy.push(0);
    }

    return parsedAcvitiy;
}


export const ProjectsActivityPrediciton = ({projects}) => {

    let weeks = [];
    const today = new Date();

    for(let i = 0; i<12; i++)
    {
        let date = new Date(today);
        date.setDate(date.getDate() + (7 * i));
        weeks.push(getISOWeek(date));
    }

    projects.forEach(prj => parseActivity(prj.projectActivity.activity));
    return (
        <StyledProjectsActivityPrediciton>
            <div className="predictionHeader">
                <div className="filler"/>
                {
                    weeks.map((week, i) => <div className='predictionWeek' key={i}>U{week}</div>)
                }
            </div>
            <div className="predictionContent">
                {projects.map(prj => <ActivityProject key={prj.projectUuid} projectName={prj.projectName} activity={parseActivity(prj.projectActivity.activity)}/>)}
            </div>
        </StyledProjectsActivityPrediciton>
    )
}

const StyledProjectsActivityPrediciton = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: ${({theme}) => theme.spacing.sm};
    overflow: hidden;

    div.predictionHeader
    {
        display: flex;
        gap: ${({theme}) => theme.spacing.sm};

        div.filler
        {
            width: 25%;
        }

        div.predictionWeek
        {
            flex: 1;
            text-align: center;
            color: ${({theme}) => theme.colors.mutedForeground};
            font-size: ${({theme}) => theme.fontSize.sm};
            font-weight: 500;
        }
    }

    div.predictionContent
    {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: ${({theme}) => theme.spacing.sm};
        overflow: auto;
    }
`

const ActivityProject = ({projectName, activity}) => {
    const sum = activity.reduce((a, b) => a+b, 0);
    if(sum <= 0) return null;
    return (
        <StyledActivityProject>
            <div className="projectName">{projectName}</div>
            {
                activity.map((act, i) => <ActivityBox key={i} activity={act}/>)
            }
            
        </StyledActivityProject>
    )
}

const StyledActivityProject = styled.div`
    display: flex;
    gap: ${({theme}) => theme.spacing.sm};
    align-items: center;

    div.projectName
    {
        flex: 0 1 25%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        font-weight: 600;
    }
`

const ActivityBox = ({activity}) => {
    return (
        <StyledActivityBox $activity={activity}>
            {activity}
        </StyledActivityBox>
    )
}

const StyledActivityBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: default;
    font-size: ${({theme}) => theme.fontSize.sm};
    font-weight: 500;
    background: rgba(${
        ({$activity, theme}) => $activity < 1 ? theme.colors.neutralSecondaryBackgroundRGB : theme.colors.accentForegroundRGB
    },
        ${({$activity}) => $activity < 1 ? 1
                        : $activity < 10 ? 0.25
                        : $activity < 20 ? 0.5
                        : $activity < 30 ? 0.75 : 1}
    );
    color: ${({theme, $activity}) => $activity < 1 ? 'transparent'
                                    : $activity < 20 ? theme.colors.neutralPrimaryForeground
                                    : theme.colors.neutralPrimaryBackground};
    
    border: 1px solid ${({$activity, theme}) => $activity < 1 ? theme.colors.neutralPrimaryBorder : 'transparent'};
    flex: 1 0 0;
    min-width: 0;
    padding: ${({theme}) => theme.spacing.md};
    border-radius: ${({theme}) => theme.cornerRadius.sm};

    &:hover
    {
        filter: brightness(0.90);
    }
`